import { createReducer, on } from "@ngrx/store";

import { AddressAction } from "./address.action";
import { AddressState } from "./address.model";

const INITIAL_STATE: AddressState = {
	departments: [],
	allMunicipalities: [],
	success: false,
	error: undefined,
	isBusy: false,
};

export const addressReducer = createReducer(
	INITIAL_STATE,
	on(AddressAction.getAddresses, (state) => ({
		...state,
		success: false,
		error: undefined,
		isBusy: true,
	})),
	on(AddressAction.getAddressesSuccess, (state, { response }) => ({
		...state,
		departments: response.departments,
		allMunicipalities: response.allMunicipalities,
		success: true,
		error: undefined,
		isBusy: false,
	})),
	on(AddressAction.getAddressesFail, (state, { error }) => ({
		...state,
		departments: [],
		allMunicipalities: [],
		success: false,
		error,
		isBusy: false,
	}))
);
